import { render, staticRenderFns } from "./oldItemRecoveryDialog.vue?vue&type=template&id=5f884452&scoped=true"
import script from "./oldItemRecoveryDialog.vue?vue&type=script&lang=js"
export * from "./oldItemRecoveryDialog.vue?vue&type=script&lang=js"
import style0 from "./oldItemRecoveryDialog.vue?vue&type=style&index=0&id=5f884452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f884452",
  null
  
)

export default component.exports